import { withSvgIcon } from './withSvgIcon';

export const Check = withSvgIcon(
  <path
    d="M7.75725 11.7661L6.97638 11.1414L5.72699 12.7032L6.50786 13.3279L7.75725 11.7661ZM11.0418 15.6744L10.4171 16.4552C10.6388 16.6326 10.9255 16.7074 11.2057 16.6608C11.4858 16.6143 11.733 16.4508 11.8854 16.2112L11.0418 15.6744ZM17.3583 7.61097L17.8952 6.76731L16.2079 5.69356L15.671 6.53722L17.3583 7.61097ZM6.50786 13.3279L10.4171 16.4552L11.6665 14.8935L7.75725 11.7661L6.50786 13.3279ZM11.8854 16.2112L17.3583 7.61097L15.671 6.53722L10.1981 15.1375L11.8854 16.2112Z"
    fill="currentColor"
  />,
  { viewBox: '0 0 24 24' },
);
